import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import ExitButton from './ExitButton';

const ESC_KEY_CODE = 27;

class Dialog extends Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    onRequestClose: PropTypes.func,
    open: PropTypes.bool,
    preview: PropTypes.bool,
    closeInOverlay: PropTypes.bool,
    escToClose: PropTypes.bool,
    animateIn: PropTypes.bool,
  };

  static defaultProps = {
    style: null,
    className: null,
    children: null,
    open: false,
    preview: false,
    escToClose: true,
    closeInOverlay: true,
    animateIn: true,
    onRequestClose: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.open && !this.props.open) {
      this.setState({
        open: true,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  togglePageScroll() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = this.props.open ? 'hidden' : '';
    }
  }

  requestCloseDialog = () => this.props.onRequestClose();

  handleKeydown = event =>
    this.isOpen() &&
    this.props.escToClose &&
    event.keyCode === ESC_KEY_CODE &&
    this.requestCloseDialog();

  handleDialogTransitionEnd = () => this.setState({ open: this.props.open });

  handleCloseInOverlay = () =>
    this.isOpen() && this.props.closeInOverlay && this.requestCloseDialog();

  isOpen = () => {
    return this.props.open && this.state.open;
  };

  render() {
    const { className, style, classes, children, open, preview } = this.props;
    if (preview) {
      return (
        <div className={classNames(classes.dialog, classes.dialogPreview, className)} style={style}>
          {children}
          <ExitButton onClick={() => {}} />
        </div>
      );
    }

    this.togglePageScroll();

    if (!this.isOpen()) {
      return null;
    }

    return (
      <div className={classes.root}>
        <div
          className={classNames(classes.overlay, !open && classes.overlayHidden)}
          onClick={this.handleCloseInOverlay}
          role="presentation"
        />
        <div
          onTransitionEnd={this.handleDialogTransitionEnd}
          className={classNames(classes.dialog, !open && classes.dialogHidden, className)}
          style={style}
        >
          {children}
          <ExitButton onClick={this.requestCloseDialog} />
        </div>
      </div>
    );
  }
}

const stylesheet = theme => ({
  root: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9,
  },
  overlay: {
    animation: ({ animateIn }) =>
      animateIn ? `overlayIn ${theme.transitions.duration.short}ms` : '',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.common.lightBlack,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  overlayHidden: {
    opacity: 0,
    transition: `opacity ${theme.transitions.duration.short}ms`,
    animation: 'none',
  },
  '@keyframes overlayIn': {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
  '@keyframes dialogIn': {
    '0%': { transform: 'translateY(-5%)', opacity: 0 },
    '100%': { transform: 'translateY(0)', opacity: 1 },
  },
  dialog: {
    backgroundColor: 'white',
    padding: theme.spacing.large,
    width: `calc(100vw - ${12 * theme.spacing.unit}px)`,
    maxWidth: 760 + 8 * theme.spacing.unit,
    maxHeight: `calc(100vh - ${12 * theme.spacing.unit}px)`,
    position: 'relative',
    opacity: 1,
    boxShadow: theme.shadows[10],
    overflow: 'auto',
    animationName: 'dialogIn',
    animationDuration: theme.transitions.duration.short,
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      width: 'auto',
      maxHeight: 'none',
      boxShadow: 'none',
      padding: 6 * theme.spacing.unit,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    [theme.breakpoints.down('xs')]: {
      padding: `${6 * theme.spacing.unit}px ${4 * theme.spacing.unit}px`,
    },
  },
  dialogHidden: {
    transform: 'translateY(-5%)',
    opacity: 0,
    transition: `opacity ${theme.transitions.duration.short}ms, transform ${
      theme.transitions.duration.short
    }ms`,
    animation: 'none',
  },
  dialogPreview: {
    position: 'relative',
    top: 0,
    left: 0,
    zIndex: 0,
    animationName: 'dialogIn',
  },
});

export default injectSheet(stylesheet)(Dialog);



// WEBPACK FOOTER //
// ./src/site-render/src/Dialog/Dialog.js